import { motion } from "framer-motion";

function HeroText() {
  const container = {
    hidden: { opacity: 0, x: 5 },
    show: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 1,
        ease: [0.6, 0.01, -0.05, 0.95],
        staggerChildren: 0.7,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, x: 5 },
    show: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.8,
        ease: [0.6, 0.01, -0.05, 0.95],
      },
    },
  };

  return (
    <motion.div variants={container} initial="hidden" animate="show" className="max-w-3xl">
      <motion.span className="text-textWhite font-extrabold" variants={item}>
        Hello There👋
      </motion.span>
      <motion.span
        className=" text-6xl lg:text-7xl font-extrabold block text-textGrey"
        variants={item}
      >
        I’m Parsa
      </motion.span>
      <motion.h1 className="leading-tight text-6xl lg:text-7xl font-extrabold " variants={item}>
        A <motion.span className="text-primary">Creative </motion.span>
        Frontend Developer
      </motion.h1>
      <motion.a
        href="#contact"
        variants={item}
        className="el-buttonType text-black bg-primary mt-6 mx-auto"
      >
        contact me
      </motion.a>
    </motion.div>
  );
}

export default HeroText;
